// extracted by mini-css-extract-plugin
module.exports = {"error":"error--1pzwO","errorPage":"errorPage--2Otqk"};